export default function createReducer(initialState, actionHandlers) {
  return (state = initialState, action) => {
    const fn = actionHandlers[action.type];
    let updatedState = state;

    if (fn) {
      updatedState = fn(state, action);
    }

    return updatedState;
  };
}



// WEBPACK FOOTER //
// ./src/redux/utils/create-reducer.js